import {
  createContext,
  Dispatch,
  SetStateAction,
  useMemo,
  useState,
} from "react";
import { QualifiedFeatureFragment } from "fe-common/graphql";

export interface DiagnosticsAPI {
  cases?: QualifiedFeatureFragment[];
  setCases?: Dispatch<SetStateAction<QualifiedFeatureFragment[]>>;
  disease?: QualifiedFeatureFragment;
  setDisease?: Dispatch<QualifiedFeatureFragment>;
}

export const useDiagnosticsContext = (): DiagnosticsAPI => {
  const [cases, setCases] = useState<QualifiedFeatureFragment[]>([]);
  const [disease, setDisease] = useState<QualifiedFeatureFragment>(null);

  return useMemo(
    () => ({
      cases,
      setCases,
      disease,
      setDisease,
    }),
    [cases, setCases, disease, setDisease],
  );
};

export const DiagnosticsContext = createContext<DiagnosticsAPI>({});
